import { Component, OnInit } from '@angular/core';
import { CongratulationService } from './congratulation.service';

@Component({
  selector: 'app-congratulations',
  templateUrl: './congratulations.component.html',
  styleUrls: ['./congratulations.component.scss'],
})
export class CongratulationsComponent implements OnInit {
  personId: string;
  applicantId: string = '';

  constructor(private CongratulationService: CongratulationService) {
  this.personId = localStorage.getItem('personId') || '';
  }

  ngOnInit() {
    
  }

  clearLocalStorage() {
    localStorage.clear();
  }
}